import { GeoJsonLayer } from '@deck.gl/layers';
import { IZoneArea } from '@helpers/types';
import { hexToRgb } from '@utils/colors';
import { Feature, Polygon } from 'geojson';
import { useMemo } from 'react';

interface AreaWithGeometry extends IZoneArea {
  geometry?: Polygon;
}

export const useDeckAreas = (areas: Array<AreaWithGeometry> | undefined) => {
  const layers = useMemo(() => {
    if (!areas) return [];

    const features: Feature<Polygon>[] = areas
      .filter((area) => {
        const hasFeatureGeometry = !!(area.feature && area.feature.geometry);
        const hasDirectGeometry = !!area.geometry;
        return hasFeatureGeometry || hasDirectGeometry;
      })
      .map((area) => {
        const geometry = area.geometry || area.feature!.geometry;
        return {
          type: 'Feature' as const,
          geometry: geometry as Polygon,
          properties: {
            name: area.name,
            color: area.color || '#888888',
          },
        };
      });

    return [
      new GeoJsonLayer({
        id: 'areas-layer',
        data: features,
        pickable: false,
        stroked: true,
        filled: true,
        lineWidthMinPixels: 1,
        getFillColor: (d: any) => [...hexToRgb(d.properties.color), 13],
        getLineColor: [136, 136, 136, 255],
        getLineWidth: 0.5,
      }),
    ];
  }, [areas]);

  return { layers };
};
